import { useState } from 'react';
import { covered, colorOf, short, chipClassFor } from '../../utils/helpers';

const SIDES = [['3', 'RD'], ['2', 'ND'], ['1', 'ST']];
const DOZENS = ['1-12', '13-24', '25-36'];
const OUTSIDE = [
  ['low', '1-18'], ['even', 'EVEN'],
  ['red', <div className="dia" />], ['black', <div className="dia black" />],
  ['odd', 'ODD'], ['high', '19-36'],
];

function Cell({ ctx, k, base, style, children }) {
  const { bets, phase, hover, hoverSet, result, winKey, onBet, setHover, landKey } = ctx;
  const amt = bets[k];
  const cov = covered(k);
  const cls = ['cell', base];
  if (hover && (k === hover || hoverSet.has(k))) cls.push('hl');
  if (result && k === 'n:' + winKey) cls.push('win');
  if (result && amt && cov.includes(winKey)) cls.push('winbet');
  const lost = result && !cov.includes(winKey);
  return (
    <div
      className={cls.join(' ')}
      style={style}
      onClick={(e) => onBet(k, e.currentTarget)}
      onMouseEnter={() => phase !== 'spin' && setHover(k)}
      onMouseLeave={() => setHover(null)}
    >
      {children}
      {amt ? (
        <div className={`chip stake ${chipClassFor(amt)}${lost ? ' lost' : ''}${landKey === k ? ' land' : ''}`}>
          <span>{short(amt)}</span>
        </div>
      ) : null}
    </div>
  );
}

export default function Board({ bets, phase, win, onBet, landKey }) {
  const [hover, setHover] = useState(null);

  const hoverSet = hover ? new Set(covered(hover).map((n) => 'n:' + n)) : null;
  const result = phase === 'result';
  const winKey = String(win);

  const ctx = { bets, phase, hover, hoverSet, result, winKey, onBet, setHover, landKey };

  const numbers = [];
  for (let r = 0; r < 3; r++) {
    for (let c = 0; c < 12; c++) {
      const n = c * 3 + 3 - r;
      numbers.push(
        <Cell ctx={ctx} key={n} k={'n:' + n} base={`num ${colorOf(n)}${r === 0 ? ' top' : ''}`} style={{ gridColumn: c + 2, gridRow: r + 1 }}>
          <i>{n}</i>
        </Cell>
      );
    }
  }

  return (
    <div className="board" id="board">
      <div className="zero-col">
        <Cell ctx={ctx} k="n:00" base="zero"><span>00</span></Cell>
        <Cell ctx={ctx} k="n:0" base="zero"><span>0</span></Cell>
      </div>

      {numbers}

      {SIDES.map((t, r) => (
        <Cell ctx={ctx} key={t[0]} k={'col:' + t[0]} base={`side${r === 0 ? ' top' : ''}`} style={{ gridColumn: 14, gridRow: r + 1 }}>
          {t[0]}{t[1]}
        </Cell>
      ))}

      {DOZENS.map((t, i) => (
        <Cell ctx={ctx} key={t} k={'doz:' + (i + 1)} base={`wide${i === 0 ? ' edge' : ''}`} style={{ gridColumn: `${2 + i * 4} / span 4`, gridRow: 4 }}>
          {t}
        </Cell>
      ))}

      {OUTSIDE.map((t, i) => (
        <Cell ctx={ctx} key={t[0]} k={t[0]} base={`wide${i === 0 ? ' edge' : ''}`} style={{ gridColumn: `${2 + i * 2} / span 2`, gridRow: 5 }}>
          {t[1]}
        </Cell>
      ))}
    </div>
  );
}
